<template>
  <f7-page no-swipeback infinite @infinite="loadMore" :infinite-preloader="false" :infinite-distance="20">
    <f7-navbar>
      <f7-nav-left>
        <f7-link icon-ios="f7:menu" icon-md="material:menu" panel-open="left"/>
      </f7-nav-left>
      <f7-nav-title>{{$t('title.manageRequests')}}</f7-nav-title>
      <f7-nav-right>
        <f7-link :class="{disabled: noRequests}" @click="openSearch" icon-ios="f7:search_strong"
                 icon-md="material:search"/>
      </f7-nav-right>
      <f7-subnavbar sliding>
        <f7-segmented>
          <f7-button :href="links.manageRequests" tab-link tab-link-active>{{$t('title.manage')}}</f7-button>
          <f7-button :href="links.myRequests" tab-link>{{$t('title.myRequests')}}</f7-button>
        </f7-segmented>
        <f7-searchbar ref="request_search" expandable search-container=".request-list" search-in=".item-title"
                      @searchbar:search="search = true" @searchbar:disable="search = false"/>
      </f7-subnavbar>
    </f7-navbar>
    <request-filter v-if="!noRequests && !search" :budgets="budgets" @show-processed="showProcessed = $event"
                    @set-filter="filterBudgetId = $event"/>
    <f7-block v-if="!search">
      <p v-if="noRequests">{{$t('text.noManageRequests')}}</p>
      <p v-else class="text-align-right">{{$tc('title.request', requests.length, {count: requests.length})}}</p>
    </f7-block>
    <f7-list v-show="!showProcessed" class="request-list">
      <f7-list-item v-for="req in displayedRequests" :key="req.id" :link="`${links.request}/${req.id}/manage`"
                    :header="req.created | toDate"
                    :title="title(req)" :after="formatMoney(req.currency, req.amount)"
                    :footer="$t('label.pendingApproval')">
      </f7-list-item>
    </f7-list>
    <f7-list v-show="showProcessed" class="request-list">
      <f7-list-item v-for="req in displayedRequests" :key="req.id" :link="`${links.request}/${req.id}/manage`"
                    :header="req.created | toDate"
                    :title="title(req)" :after="formatMoney(req.currency, req.amount)"
                    :footer="proccessedFooter(req)">
        <f7-icon slot="media" :f7="req | listIcon" :color="req | iconColor"/>
      </f7-list-item>
    </f7-list>
    <div v-show="showPreloader && !search" class="preloader infinite-scroll-preloader"></div>
    <main-toolbar slot="fixed" :active="1"/>
  </f7-page>
</template>

<script>
  import helpers from '@/utils/helpers'
  import MainToolbar from '../components/main-toolbar'
  import RequestFilter from '@/components/request-filter'
  import requestList from '@/utils/request-list'

  export default {
    name: 'manage-requests',
    components: {
      MainToolbar,
      RequestFilter
    },
    computed: {
      noRequests () {
        return this.pendingRequests.length === 0 && this.processedRequests.length === 0
      },
      requests () {
        const requests = this.showProcessed ? this.processedRequests : this.pendingRequests
        return this.filterBudgetId ? requests.filter(r => r.potId === this.filterBudgetId) : requests
      }
    },
    created () {
      this.$store.dispatch('requests/fetchManaged')
    },
    data () {
      return {
        search: false
      }
    },
    methods: {
      openSearch () {
        this.$refs.request_search.enable()
        this.$refs.request_search.$el.getElementsByTagName('input')[0].focus()
      },
      title (r) {
        return `${this.userName(this.myTeam.find(u => u.id === r.userId))} for ${r.reason}`
      }
    },
    mounted () {
      const budgetId = parseInt(this.$f7route.params.budget_id)
      if (budgetId) this.$bus.$emit('init-filter', budgetId)
    },
    mixins: [helpers, requestList]
  }
</script>

<style lang="scss" scoped>
</style>
